import React, { memo, useMemo } from 'react';
import ConfluenceHomeBanner from '@post-office/browser--growth/confluence-home-banner/placement';

import {
	PlacementFetchProvider,
	usePlacementPreloadedData,
} from '@atlassian/confluence-post-office-provider/entry-points/preload-placement';
import { Placement } from '@atlassian/post-office-placement';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';

export const HomeBanner: React.MemoExoticComponent<() => React.JSX.Element> = memo(
	(): React.JSX.Element => {
		const [preloadedInitialData] = usePlacementPreloadedData('confluence-home-banner');
		const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();

		const memoizedPlacementProps = useMemo(
			() => ({
				preloadedInitialData,
			}),
			[preloadedInitialData],
		);

		return (
			<div
				role="banner"
				data-testid="confluence-home-banner-placement"
				data-vc="confluence-home-banner-placement"
				{...ssrPlaceholderIdProp}
			>
				<PlacementFetchProvider>
					<Placement
						placementId="confluence-home-banner"
						// @ts-ignore - Type 'ComponentType<Partial<ErrorBoundaryPropsWithRender>> is not assignable to type 'PlacementComponent<LocalPlacementProps>'
						PlacementComponent={ConfluenceHomeBanner}
						placementProps={memoizedPlacementProps}
						disableInitialData={Boolean(preloadedInitialData)}
					/>
				</PlacementFetchProvider>
			</div>
		);
	},
);

export const PostOfficeHomeBanner: React.NamedExoticComponent<{}> = memo(
	withTransparentErrorBoundary({
		attribution: Attribution.POST_OFFICE,
	})(HomeBanner),
);
